<template>
  <div>
    <div class="bigBox">
      <div v-show="!this.knowedgeQeck" class="workcenter">
        <Card dis-hover class="sum-card-box2">
          <div class="center-01">
            <h3>我猜您想解决以下问题：</h3>

            <div @click="tiaozhaun(2)">
              <Icon type="md-add" size="20" />
            </div>
          </div>
          <div class="center-02">
            <div>
              <Input v-model="descr" placeholder="请输入关键词" clearable @on-change="Search1(descr)" icon="ios-search" />
            </div>
            <div class="center-03">
              <Table :columns="columns" :data="data" stripe highlight-row @on-row-click="rowClick"></Table>
            </div>
          </div>
        </Card>
      </div>
      <div v-show="this.knowedgeQeck" class="workcenter">
        <Card dis-hover class="sum-card-box2">
          <div class="center-01">
            <h3>工单处理常用语：</h3>

            <div @click="tiaozhaun(3)">
              <Icon type="md-add" size="20" />
            </div>
          </div>
          <div class="center-02">
            <div>
              <Input v-model="descr2" placeholder="请输入关键词" clearable @on-change="Search2(descr2)" icon="ios-search" />
            </div>
            <div class="center-03">
              <Table :columns="columns2" :data="data2" stripe highlight-row @on-row-click="rowClick2"></Table>
            </div>
          </div>
        </Card>
      </div>
      <div class="workleft">
        <div v-if="!patient" class="radio-work">
          <el-radio-group size="mini" @input="changeCall" v-model="radio1">
            <el-radio-button label="需要派单"></el-radio-button>
            <el-radio-button label="不需要派单"></el-radio-button>
          </el-radio-group>
        </div>

        <Form ref="form" :model="forms" :label-width="150" :disabled="action == 'view' ? true : false">

          <div v-if="!patient" v-show="!this.knowedgeQeck" class="first-line">
            <p style="color: #00050e;
          font-size: 0.875rem;
          padding-top: 5px;
          text-align: left;
          width:8%;
          display: inline-block;
          margin-right: 5px ">问题描述:</p>
            <div class="left-01">
              <Icon v-show="getText" type="ios-close-circle" @click="clearGetText()" class="clear_icon" size="16" />
              <Input v-model="getText" type="textarea" :autosize="{ minRows: 3, maxRows: 3 }"
                placeholder="请输入或点击左侧选择"></Input>
            </div>
          </div>
          <div v-if="!patient" v-show="!this.knowedgeQeck" class="first-line">
            <div class="left-02" v-html="programme"></div>
          </div>
          <div v-show="this.knowedgeQeck" class="first-line">
            <p style="color: #00050e;
          font-size: 0.875rem;
          padding-top: 5px;
          text-align: left;
          width:8%;
          display: inline-block;
          margin-right: 5px ">处理内容:</p>
            <div class="left-01">
              <Input v-model="maintainerContent" type="textarea" :autosize="{ minRows: 3, maxRows: 3 }"
                placeholder="请输入或点击左侧选择"></Input>
            </div>
          </div>
          <div v-show="this.knowedgeQeck" class="first-line">
            <p style="color: #00050e;
          font-size: 0.875rem;
          padding-top: 5px;
          text-align: left;
          width:8%;
          display: inline-block;
          margin-right: 5px ">故障原因:</p>
            <div class="left-01">
              <Select class="SelectT" v-model="teackRemark" filterable placeholder="请选择故障原因" clearable="true">
                <Option v-for="item in teackList" :value="item.id" :key="item.id">{{ item.descr }}
                </Option>
              </Select>
            </div>
          </div>
          <div v-if="!patient" class="second-line">
            <div>
              <p><span style="color: red">*</span> 科室信息:</p>
              <el-select
                  v-model="DepartmentValue"
                  class="SelectDesk"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请选择或搜索科室"
                  :remote-method="remoteMethod1"
                  @change="OnDepartment(DepartmentValue)"
                  :loading="loading1">
                <el-option
                    v-for="item in deskList"
                    :key="item.id"
                    :label="item.deskName"
                    :value="item.id">
                </el-option>
              </el-select>
            </div>

          </div>
          <div v-if="patient" class="third-line">
            <div>
              <p><span style="color: red">*</span> 病人信息:</p>
              <Select class="SelectDesk" v-model="patientId" filterable placeholder="请选择病人信息" clearable="true">
                <Option v-for="item in patientList" :value="item.id" :key="item.id">{{ item.patientName }}
                </Option>
              </Select>
            </div>

          </div>
          <div v-if="patient" class="third-line">

            <div>
              <p><span style="color: red">*</span> 患者所在科室:</p>
              <Select class="SelectDesk" v-model="deskId" filterable placeholder="请选择或搜索科室" clearable="true">
                <Option v-for="item in transportList" :value="item.id" :key="item.id">{{ item.deskName }}
                </Option>
              </Select>
            </div>
          </div>
          <div v-if="patient" class="third-line">
            <div>
              <p><span style="color: red">*</span> 护送到手术间:</p>
              <Select class="SelectDesk" v-model="transferDeskId" filterable placeholder="请选择或搜索科室" clearable="true">
                <Option v-for="item in operationRoonmList" :value="item.id" :key="item.id">{{ item.deskName }}
                </Option>
              </Select>
            </div>
          </div>


          <div v-if="!patient" class="first-line">
            <div>
              <p>设备信息:</p>
              <el-select class="Select" v-model="EquipmentValue" filterable remote reserve-keyword
                         :remote-method="remoteMethod2" placeholder="请选择或搜索设备信息" clearable="true" :loading="loading2"
                         @change="SelectEquipment(EquipmentValue)">
                <el-option v-for="item in EquipmentList" :value="item.Num" :key="item.id" :label="item.value">
                </el-option>
              </el-select>
            </div>
            <div>
              <p><span style="color: red">*</span>故障类型:</p>
              <Select class="Select" v-model="typeId" placeholder="请选择问题或故障类型" filterable @on-change="changeTypeId(typeId)">
                <Option v-for="item in workList" :value="item.typeId" :key="item.typeId">{{ item.name }}
                </Option>
              </Select>
            </div>
          </div>
          <div v-if="!patient" class="first-line">
            <div>
              <p style="display: inline"> 报修人:</p>
              <Input class="Select" v-model="repairBy" placeholder="请输入报修人"></Input>
            </div>
            <div>
              <p>报修电话:</p>
              <Input class="Select" v-model="repairPhone" placeholder="请输入报修电话"></Input>
            </div>
          </div>
          <div v-if="!patient" v-show="!this.knowedgeQeck" class="workleft-1">
            <div class="workleft-11">
              <RadioGroup v-model="sendType" @on-change="changeOrderType(sendType)" class="RadioGroup">

                <Radio :label="2">自动派单</Radio>
                <Radio :label="3">抢单派单</Radio>
                <Radio :label="1">手动派单</Radio>
              </RadioGroup>
              <Select class="left-12-Select" v-model="engineer1" placeholder="请选择维修员" clearable="true"
                @on-change="Selectengineer2(engineer1)" v-show="single == false ? true : false">
                <Option v-for="item in engineerList2" :value="item.nickName" :key="item.userId">{{ item.nickName }}
                </Option>
              </Select>
            </div>
          </div>
          <div v-if="patient" class="workleft-6">
            <div class="workleft-66">
              <RadioGroup v-model="sendTypePatient" @on-change="changeOrderTypePatient(sendTypePatient)"
                class="RadioGroup">
                <Radio :label="2">自动派单</Radio>
                <Radio :label="3">抢单派单</Radio>
                <Radio :label="1">手动派单</Radio>
              </RadioGroup>

              <Select class="left-66-Select" v-model="engineerPatient" placeholder="请选择护工" clearable="true"
                v-show="singlePatient == false ? true : false" @on-change="SelectengineerPatient(engineerPatient)">
                <Option v-for="item in engineerListPatient" :value="item.name" :key="item.id">{{ item.name }}
                </Option>
              </Select>
            </div>
          </div>

          <div v-show="this.knowedgeQeck" class="service-line">
            <div>
              <p><span style="color: red">*</span> 服务类型:</p>
              <Select class="Select" v-model="service" filterable placeholder="请选择服务类型" clearable="true">
                <Option v-for="item in serviceList" :value="item.service" :key="item.service">{{ item.service }}
                </Option>
              </Select>
            </div>


          </div>
          <div v-show="this.knowedgeQeck" class="compare-line">
            <div>
              <p style="display: inline">处理状态:</p>
              <Input class="Select" v-model="state" disabled></Input>
            </div>

          </div>
          <div v-if="patient" class="workleft-2">
            <Button type="info" @click="newWorkPatient" size="default" class="button2">保 存
            </Button>
          </div>
          <div v-if="!patient" v-show="!this.knowedgeQeck" class="workleft-2">
            <Button type="info" @click="handleSubmit" size="default" class="button2">保 存
            </Button>
          </div>
          <div v-show="this.knowedgeQeck" class="workleft-3">
            <Button type="info" @click="handleSubmit" size="default" class="button2">保 存
            </Button>
          </div>
          <!--          <div v-show="this.knowedgeQeck" class="workleft-4">-->
          <!--            <Button-->
          <!--                type="info"-->
          <!--                @click="handleSubmitKnow"-->
          <!--                size="default"-->
          <!--                class="button2"-->
          <!--            >保存并转存知识库-->
          <!--            </Button>-->
          <!--          </div>-->
        </Form>
      </div>
    </div>
  </div>
</template>
<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
import siblingCall from "@/utils/siblingCall";

export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      data: [],
      data2: [],
      descr: "",
      patient: false,
      allData: [],
      typeId: "",
      descr2: "",
      allData2: [],
      serviceList: [
        {
          service: '服务类',
          lable: '服务类'
        }, {
          service: '换修类',
          lable: '换修类'
        }, {
          service: '新增类',
          lable: '新增类'
        },
      ],
      service: "服务类",
      radio1: "需要派单",
      DepartmentValue: "",
      EquipmentValue: "",
      color1: true,
      sendType: 2, //派单类型
      single: true,
      getText: "",
      maintainerContent: "",
      programme: "",
      EquipmentList: {}, //设备列表
      workList: {},
      engineerList2: {},
      maintainerId: "",
      engineer1: "",
      repairPhone: "",
      repairBy: "",
      color2: false,
      mname: "work",
      teackRemark: "",
      deskList: [], //科室列表
      transportList: [], //科室列表
      operationRoonmList: [], //科室列表
      teackList: [], //故障原因列表
      RepairText: "",
      state: "已完成",
      key: "id",
      columns: [
        {
          title: "问题描述",
          minWidth: 170,
          align: "left",
          key: "descr",
        },
      ], columns2: [
        {
          title: "处理内容",
          minWidth: 170,
          align: "left",
          key: "descr2",
        },
      ],
      knowedgeQeck: false,
      url: {},
      //手术转运
      //派单类型
      sendTypePatient: 1,
      //展示护工
      singlePatient: true,
      //起点科室
      deskId: "",
      //目标科室
      transferDeskId: "",
      nursingId: "",
      //病人信息
      patientId: "",
      patientList: {},
      //护工id
      engineerPatient: "",
      //护工列表
      engineerListPatient: {},
      loading1: false,
      loading2: false,
    };
  },
  computed: {
    extRender() {
      return ["change"];
    },
  },
  mounted() {
  },
  async created() {

    await this.changePatient()
    await this.loadfaultData();
    await this.patientListMethod();
    this.changeOrderType(2);
    this.repairPhone = this.phone
    this.changeOrderTypePatient(this.sendTypePatient)
    await this.loadTypeData()
    await this.deskListMethod();

    await this.loadWorkCommon();
    await this.loadCommonData2()
    await this.loadCommonData()
    let query = this.$route.query;
    if (query.phone) {
      this.repairPhone = query.phone
      await this.loadDeskData(this.repairPhone)
    }
    await this.deskListTransport()
    await this.getOperationRoonmList()
    // this.loadworkData();
  },
  methods: {
    async remoteMethod1(query) {
      let d = {}
      this.loading1 = true
      if (query !== "") {
        d.deskName = query
      }
      console.log(query)
      let res = await $utils.api.load("/admin/system/desk/selectList", d, "get");
      if (res && res.rows) {

        this.loading1 = false
        this.deskList = res.rows;
        for (let i = 0; i < this.deskList.length; i++) {
          let workInfotemp = "";
          if (this.deskList[i].deskName !== null && this.deskList[i].deskName !== undefined) {
            workInfotemp = this.deskList[i].deskName;
          }
          if (this.deskList[i].principal !== null && this.deskList[i].principal !== undefined) {
            workInfotemp = workInfotemp + "/" + this.deskList[i].principal;
          }
          if (this.deskList[i].phone !== null && this.deskList[i].phone !== undefined) {
            workInfotemp = workInfotemp + "/" + this.deskList[i].phone;
          }
          if (this.deskList[i].address !== null && this.deskList[i].address !== "") {
            workInfotemp = workInfotemp + "/" + this.deskList[i].address;
          }
          this.deskList[i].deskName = workInfotemp;
        }
        console.log(this.deskList)
      } else {
        this.loading1 = false
      }
    },

    async remoteMethod2(query) {
      let d = {}
      this.loading2 = true
      if (query !== "") {
        d.facilityName = query
      }
      let res = await $utils.api.load("/admin/system/facility/selectListSearch", d, "get");
      if (res && res.rows) {

        this.loading2 = false
        let list = res.rows;
        let arr = []
        if (list.length > 0) {
          for (let i = 0; i < list.length; i++) {
            let item = list[i];
            let obj = {};
            obj.deskId = item.deskId;
            obj.value = item.assetNum + "_" + item.facilityName + "_" + item.facilityType;
            obj.Num = item.facilityNum;
            arr.push(obj);
          }
        }
        this.EquipmentList = arr;

      } else {
        this.loading2 = false
      }
    },
    clearGetText(){
      this.getText = ""
      this.programme = ""
    },
    //选择维修员
    Selectengineer2(item) {
      if (this.engineerList2.length > 0) {
        for (let i = 0; i < this.engineerList2.length; i++) {
          let a = this.engineerList2[i];
          if (a.nickName == item) {
            this.maintainerId = a.userId;
          }
        }
      }
    },

    //选择设备
    async SelectEquipment(item) {
      let list = this.EquipmentList;
      if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          let a = list[i];
          if (!item) {
            await this.loadCommonData(null)
          }
          if (a.Num == item) {
            this.facilityNo = a.Num;
            this.DepartmentValue = a.deskId
            await this.loadfaultData(this.facilityNo)
          }
        }
      }
    },
    async Department(id) {
      if (id == undefined) {
        return;
      } else {
        let res = await $utils.api.load(`/admin/system/desk/${id}`);
        if (res.code === 200) {
          if (res.data) {
            if (res.data.isImportant == 1) {
              this.block = true
              this.isImportant = 1
            } else {
              this.block = false
              this.isImportant = 2
            }
            let workInfotemp = "";
            if (res.data.principal !== null && res.data.principal !== undefined) {
              workInfotemp = res.data.principal;
            }
            if (res.data.address !== null && res.data.address !== "") {
              workInfotemp = workInfotemp + "/" + res.data.address;
            }
            this.RepairText = workInfotemp;
          }
        }
      }
    },
    //选择设备
    async loadfaultData(facilityNo) {
      if (facilityNo) {
        let q = {};

        q.facilityNum = facilityNo;
        let res = await $utils.api.load(`/admin/system/facility/workTypeHome`, q);
        console.log(4444, res)
        if (res) {
          let list = res.rows;
          if (!list || list.length === 0) {
            this.workList = {}
            this.typeId = ""
            this.getText = ""
          } else {
            await this.loadCommonData(list[0].id)
            this.typeId = list[0].id
            await this.changeTypeId(this.typeId)
            await this.loadTypeData()
          }
        }
      }
    },
    //派单类型
    changeOrderType(item) {
      if (item == 1) {
        this.single = false;
      } else {
        this.single = true;
      }
    },
    changeOrderTypePatient(item) {
      if (item == 1) {
        this.singlePatient = false;
      } else {
        this.singlePatient = true;
      }
    },
    changeCall() {
      if (this.radio1 == "需要派单") {
        this.knowedgeQeck = false;
      } else {
        this.knowedgeQeck = true;
      }

    },
    //常用语跳转
    tiaozhaun(item) {
      console.log(item);
      this.$Modal.remove();
      if (item == 1) {
        $utils.url.push({
          name: "worktype_list",
        });
      } else if (item == 2) {
        $utils.url.push({
          name: "commondescr_add",
        });
      } else if (item == 3) {
        $utils.url.push({
          name: "commondescr_add_main",
        });
      }
    },
    Search1(descr) {
      let keyword = this.descr;
      let allData = this.allData;
      let newData = [];
      for (let index = 0; index < allData.length; index++) {
        let item = allData[index] || {};
        let descrOld = item.descr;
        if (descrOld.indexOf(keyword) != -1) {
          newData.push(item);
          this.data = newData;
        }
      }
    },
    Search2(descr2) {
      let keyword = this.descr2;
      let allData = this.allData2;
      let newData = [];
      for (let index = 0; index < allData.length; index++) {
        let item = allData[index] || {};
        let descrOld = item.descr2;
        if (descrOld.indexOf(keyword) != -1) {
          newData.push(item);
          this.data2 = newData;
        }
      }
    },
    async loadCommonData(id) {
      let q = {};
      q.workTypeId = id
      q.workType = 1;
      let res = await $utils.api.load("/admin/system/common/noPageCommonList", q);
      if (res) {
        if (res.code > 0) {
          let list = res.rows || [];

          this.allData = list;
          this.data = list;
        }
      }
    },
    async loadCommonData2() {
      let q = {};
      q.workType = 2;
      let res = await $utils.api.load("/admin/system/common/noPageList", q);
      if (res.code > 0) {
        console.log(7878787, res)
        let list = res.rows || [];
        let arr = []
        if (list && list.length > 0) {
          for (let i = 0; i < list.length; i++) {
            let item = list[i];
            let obj = {};
            obj.descr2 = item.descr,
              arr.push(obj);

          }
        }

        this.allData2 = arr;
        this.data2 = arr;
      }
    },
    async rowClick(row) {
      // 点击选择行
      let descr = row.descr;
      if (descr == "手术转运") {
        this.patient = true

      } else {
        this.patient = false
        this.getText = descr;
        await this.loadData(row.id);
        if (row.recommendation != "") {
          this.programme = row.recommendation;
        } else {
          this.programme = "暂无处理方案";
        }
      }
    },
    async rowClick2(row) {
      // 点击选择行

      let descr = row.descr2;
      this.maintainerContent = descr;
    },
    async loadData(id) {
      let q = {};
      q.id = id;
      let res = await $utils.api.load("/admin/system/common/pageList", q);
      if (res) {
        if (res.code > 0) {
          this.typeId = res.data.id
          this.changeTypeId(this.typeId); //查询维修员


        }
      }
    },
    SelectengineerPatient(item) {
      if (this.engineerListPatient.length > 0) {
        for (let i = 0; i < this.engineerListPatient.length; i++) {
          let a = this.engineerListPatient[i];
          if (a.name == item) {
            this.nursingId = a.id;
          }
        }
      }
    },
    async OnDepartment(DepartmentValue) {
      if (this.DepartmentValue) {
        this.EquipmentList = [];
        this.EquipmentValue = "";
      }
      let q = {};
      q.state = 2;
      q.deskId = DepartmentValue;
      let res = await $utils.api.load(
        "/admin/system/facility/selectListSearch",
        q,
        "get"
      );
      let list = res.rows;
      let arr = [];
      if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          let item = list[i];
          let obj = {};
          obj.deskId = item.deskId
          obj.value = item.assetNum + "_" + item.facilityName + "_" + item.facilityType
          obj.Num = item.facilityNum
          arr.push(obj);
        }
      } else {
        this.EquipmentValue = "";
      }
      this.EquipmentList = arr;
    },
    //选择故障类型下拉框
    async loadTypeData() {
      let q = {};
      q.typeId = this.typeId
      // 通过pk查询字典数据
      let res = await $utils.api.load('/admin/system/workType/listFrame', q);
      console.log(111, res)
      if (res && res.rows) {
        let list = res.rows;
        if (list.length > 0) {
          let lists = [];
          list.forEach((obj) => {
            lists.push({ name: obj.name, typeId: obj.id });
            if (obj.deskList && obj.deskList.length > 0) {
              obj.deskList.forEach((item) => {
                const newObj = {
                  name: `${obj.name}-${item.name}`,
                  typeId: item.id,
                };
                lists.push(newObj);
              });
            }
          });
          console.log("workTypeList", lists)
          this.workList = lists
        }
      }
    },
    async patientListMethod() {
      let type = 1
      let res = await $utils.api.load(`/admin/system/nursing/patientList/${type}`, {}, "get");
      if (res && res.rows) {
        this.patientList = res.rows;
        for (let i = 0; i < this.patientList.length; i++) {
          let workInfotemp = "";
          if (this.patientList[i].patientName !== null && this.patientList[i].patientName !== undefined) {
            workInfotemp = this.patientList[i].patientName;
          }
          if (this.patientList[i].patientId !== null && this.patientList[i].patientId !== undefined) {
            workInfotemp = workInfotemp + "/" + this.patientList[i].patientId;
          }
          this.patientList[i].patientName = workInfotemp;
        }
      }

    },
    async deskListMethod() {
      let res = await $utils.api.load("/admin/system/desk/selectList");
      if (res && res.rows) {
        this.deskList = res.rows;
        for (let i = 0; i < this.deskList.length; i++) {
          let workInfotemp = "";
          if (this.deskList[i].deskName !== null && this.deskList[i].deskName !== undefined) {
            workInfotemp = this.deskList[i].deskName;
          }
          if (this.deskList[i].principal !== null && this.deskList[i].principal !== undefined) {
            workInfotemp = workInfotemp + "/" + this.deskList[i].principal;
          }
          if (this.deskList[i].phone !== null && this.deskList[i].phone !== undefined) {
            workInfotemp = workInfotemp + "/" + this.deskList[i].phone;
          }
          if (this.deskList[i].address !== null && this.deskList[i].address !== "") {
            workInfotemp = workInfotemp + "/" + this.deskList[i].address;
          }
          this.deskList[i].deskName = workInfotemp;
        }
      }

    },
    async deskListTransport() {
      let res = await $utils.api.load("/admin/system/desk/selectListByNursing", {}, "get");
      this.transportList = res.rows;
      for (let i = 0; i < this.transportList.length; i++) {
        let workInfotemp = "";
        if (this.transportList[i].deskName !== null && this.transportList[i].deskName !== undefined) {
          workInfotemp = this.transportList[i].deskName;
        }
        if (this.transportList[i].principal !== null && this.transportList[i].principal !== undefined) {
          workInfotemp = workInfotemp + "/" + this.transportList[i].principal;
        }
        if (this.transportList[i].phone !== null && this.transportList[i].phone !== undefined) {
          workInfotemp = workInfotemp + "/" + this.transportList[i].phone;
        }
        if (this.transportList[i].address !== null && this.transportList[i].address !== "") {
          workInfotemp = workInfotemp + "/" + this.transportList[i].address;
        }
        this.transportList[i].deskName = workInfotemp;
      }
    },
    async getOperationRoonmList() {
      let res = await $utils.api.load("/admin/system/desk/selectListByNursingByOperationRoonm", {}, "get");
      this.operationRoonmList = res.rows;
      for (let i = 0; i < this.operationRoonmList.length; i++) {
        let workInfotemp = "";
        if (this.operationRoonmList[i].deskName !== null && this.operationRoonmList[i].deskName !== undefined) {
          workInfotemp = this.operationRoonmList[i].deskName;
        }
        if (this.operationRoonmList[i].principal !== null && this.operationRoonmList[i].principal !== undefined) {
          workInfotemp = workInfotemp + "/" + this.operationRoonmList[i].principal;
        }
        if (this.operationRoonmList[i].phone !== null && this.operationRoonmList[i].phone !== undefined) {
          workInfotemp = workInfotemp + "/" + this.operationRoonmList[i].phone;
        }
        if (this.operationRoonmList[i].address !== null && this.operationRoonmList[i].address !== "") {
          workInfotemp = workInfotemp + "/" + this.operationRoonmList[i].address;
        }
        this.operationRoonmList[i].deskName = workInfotemp;
      }
    },
    async loadDeskData(repairPhone) {
      // 通过pk查询字典数据
      let q = {}
      q.phonenumber = repairPhone
      let res = await $utils.api.load(`/admin/system/desk/selectUserList`, q)
      if (res && res.rows.length > 0) {
        let ll = res.rows
        this.DepartmentValue = ll[0].id
        await this.OnDepartment(this.DepartmentValue)
      }
    },
    async loadWorkCommon() {
      // 通过pk查询字典数据
      let q = {};
      q.workType = 3
      let res = await $utils.api.load("/admin/system/common/mainList", q, "get");
      if (res && res.rows) {
        this.teackList = res.rows;
      }
    },
    async changeTypeId(typeId) {
      if (typeId) {
        // this.loadChildData(typeParentId);
        // 通过pk查询字典数据
        let res = await $utils.api.load(`/admin/system/maiUser/type/${typeId}`)
        if (res && res.rows) {

          this.engineerList2 = res.rows

        }
      }
    },
    //查询维修员
    changePatient() {
      let q = {}
      // 通过pk查询字典数据
      $utils.api.load('/admin/system/user/nursinglist', q, 'get').then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let arr = [];
          if (ll.length > 0) {
            for (let i = 0; i < ll.length; i++) {
              let item = ll[i];
              let obj = {
                name: item.nickName,
                id: item.userId,
              };
              arr.push(obj);
            }
            this.engineerListPatient = arr;
          }
        }
      });
    },
    async newWorkPatient() {
      let q = {};
      if (this.deskId == "") {
        return $utils.toast.error("患者所在科室不可为空");
      }
      if (this.transferDeskId == "") {
        return $utils.toast.error("护送到手术间不可为空");
      }
      if (this.sendTypePatient == 1) {
        if (this.nursingId) {
          q.nursingId = this.nursingId
        } else {
          return $utils.toast.error("手动派单护工不可为空");
        }
      }
      q.deskId = this.deskId;
      q.transferDeskId = this.transferDeskId;
      q.id = this.patientId
      q.transferContent = this.transferContent
      q.sendType = this.sendTypePatient
      let res = await $utils.api.load("/admin/system/nursing/addNursing", q, "post");
      if (res.code == 200) {
        if (res.status) {
          $utils.toast.success("保存成功");
          setTimeout(() => {
            $utils.url.go(-1);
          }, 1000);
        }
      } else {
        $utils.toast.error("保存失败");
      }
    },
    handleSubmitKnow() {
      if (this.knowedgeQeck) {
        if (!this.maintainerContent) {
          $utils.toast.error("请填写处理内容");
          return
        }
        if (!this.service) {
          $utils.toast.error("请填写服务类型");
          return
        }
      } else {
        if (!this.getText) {
          $utils.toast.error("请填写问题描述");
          return
        }
      }

      if (!this.DepartmentValue) {
        $utils.toast.error("请选择科室");
        return
      }
      if (!this.typeId) {
        $utils.toast.error("请选择故障类型");
        return
      }
      if (this.sendType == 1) {
        if (!this.maintainerId) {
          $utils.toast.error("请选择维修员");
          return
        }
      }

      let q = {
        descr: this.getText,
        deskId: this.DepartmentValue,
        facilityNo: this.EquipmentValue,
        typeId: this.typeId,
        repairBy: this.repairBy,
        repairPhone: this.repairPhone,
        sendType: this.sendType,
        maintainerId: this.maintainerId,
        isKnow: 1,
        maintainType: 2,
        callId: this.callId,
        maintainerContent: this.maintainerContent,
        teackRemark: this.teackRemark,
        service: this.service,
        repairSource: 3,


      };
      if (this.callId) {
        q.repairSource = 4
      }
      if (this.EquipmentValue) {
        q.isFastOrder = 0
      } else {
        q.isFastOrder = 1
      }


      this.sloading = true;

      $utils.api
        .load(
          `/admin/system/work/callCenterAdd`,
          q,
          this.action == "edit" ? "PUT" : "POST"
        )
        .then((res) => {
          this.sloading = false;
          if (res.code == 200) {
            $utils.toast.success("保存成功");
            setTimeout(() => {
              $utils.url.go(-1);
            }, 1000);
          }
        })
        .catch((e) => {
          this.sloading = false;
          $utils.toast.error("保存异常" + e.message);
        });
    },
    handleSubmit() {
      if (this.knowedgeQeck) {
        if (!this.maintainerContent) {
          $utils.toast.error("请填写处理内容");
          return
        }
        if (!this.service) {
          $utils.toast.error("请填写服务类型");
          return
        }
      } else {
        if (!this.getText) {
          $utils.toast.error("请填写问题描述");
          return
        }
      }

      if (!this.DepartmentValue) {
        $utils.toast.error("请选择科室");
        return
      }
      if (!this.typeId) {
        $utils.toast.error("请选择故障类型");
        return
      }
      if (this.sendType == 1) {
        if (!this.maintainerId) {
          $utils.toast.error("请选择维修员");
          return
        }
      }
      let q = {
        descr: this.getText,
        deskId: this.DepartmentValue,
        facilityNo: this.EquipmentValue,
        typeId: this.typeId,
        repairBy: this.repairBy,
        repairPhone: this.repairPhone,
        sendType: this.sendType,
        maintainerId: this.maintainerId,
        isKnow: 0,
        maintainType: 2,
        callId: this.callId,
        maintainerContent: this.maintainerContent,
        teackRemark: this.teackRemark,
        service: this.service,
        repairSource: 3,
      };
      if (this.callId) {
        q.repairSource = 4
      }
      if (this.EquipmentValue) {
        q.isFastOrder = 0
      } else {
        q.isFastOrder = 1
      }

      if (this.knowedgeQeck) {
        q.state = 3
      } else {
        q.state = 1
      }


      this.sloading = true;
      $utils.api
        .load(`/admin/system/work/callCenterAdd`, q, "POST")
        .then((res) => {
          this.sloading = false;
          if (res.code == 200) {
            $utils.toast.success("保存成功");
          }
          setTimeout(() => {
            $utils.url.go(-1);
          }, 1000);
        })
        .catch((e) => {
          this.sloading = false;
          $utils.toast.error("保存异常" + e.message);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.bigBox {
  height: calc(667px);
  margin-top: 17px;
  display: flex;
  justify-content: space-between;

  .workleft {
    width: 100%;
    margin-left: 1%;

    .radio-work {
      margin-left: 100px;

    }

    h3 {
      margin-bottom: 10px;
    }

    .first-line {
      margin-top: calc(20px);
      width: calc(100%);
      display: flex;
      justify-content: flex-start;
      margin-bottom: 20px;

      div {
        display: flex;
        justify-content: flex-start;
        width: 100.2%;

        .SelectT {
          width: 100%;
          display: inline-block;
          margin-right: 10px;

          /deep/ .ivu-input[disabled] {
            background-color: #f3f3f3;
            opacity: 1;
            cursor: not-allowed;
            color: #3871f1;
          }

          /deep/ .ivu-select-input {
            display: inline-block;
            height: 32px;
            line-height: 32px;
            padding: 0 24px 0 8px;
            font-size: 14px;
            outline: none;
            border: none;
            box-sizing: border-box;
            color: #3871f1;
            background-color: transparent;
            position: relative;
            cursor: pointer;
          }
        }

        .Select {
          width: 83%;
          display: inline-block;
          margin-right: 10px;

          /deep/ .ivu-input[disabled] {
            background-color: #f3f3f3;
            opacity: 1;
            cursor: not-allowed;
            color: #3871f1;
          }

          /deep/ .ivu-select-input {
            display: inline-block;
            height: 32px;
            line-height: 32px;
            padding: 0 24px 0 8px;
            font-size: 14px;
            outline: none;
            border: none;
            box-sizing: border-box;
            color: #3871f1;
            background-color: transparent;
            position: relative;
            cursor: pointer;
          }
        }
        .SelectDesk {
          width: 70%;
          display: inline-block;
          margin-right: 10px;

          /deep/ .ivu-input[disabled] {
            background-color: #f3f3f3;
            opacity: 1;
            cursor: not-allowed;
            color: #3871f1;
          }

          /deep/ .ivu-select-input {
            display: inline-block;
            height: 32px;
            line-height: 32px;
            padding: 0 24px 0 8px;
            font-size: 14px;
            outline: none;
            border: none;
            box-sizing: border-box;
            color: #3871f1;
            background-color: transparent;
            position: relative;
            cursor: pointer;
          }
        }

        p {
          color: #00050e;
          font-size: 0.875rem;
          padding-top: 5px;
          text-align: left;
          width: 16.7%;
          display: inline-block;
          margin-right: 5px;
        }
      }


      .left-01 {
        display: inline-block;
        width: 90.5%;

        vertical-align: top;
        position: relative;

        .clear_icon {
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
          z-index: 2;
        }

        /deep/ .ivu-input {
          display: inline-block;
          width: 100%;
          height: calc(25%);
          line-height: 1.5;
          padding: 4px 7px;
          font-size: 14px;
          border: 1px solid #dcdee2;
          border-radius: 4px;
          color: #3871f1;
          background-color: #fff;
          background-image: none;
          position: relative;
          cursor: text;
          transition: border 0.2s ease-in-out, background 0.2s ease-in-out,
            box-shadow 0.2s ease-in-out;
        }
      }

      .left-02 {
        width: 90.7%;
        border-radius: 5px;
        background-color: #f3f3f3;
        border: 1px rgb(220, 222, 226) solid;
        height: 100px;
        overflow: auto;
        color: #ee0000;
        margin-left: 8.4%;
      }
    }

    .second-line {
      margin-top: calc(20px);
      width: calc(100%);
      display: flex;
      justify-content: flex-start;
      margin-bottom: 20px;

      div {
        display: flex;
        justify-content: flex-start;
        width: 100%;

        .SelectT {
          width: 100%;
          display: inline-block;
          margin-right: 10px;

          /deep/ .ivu-input[disabled] {
            background-color: #f3f3f3;
            opacity: 1;
            cursor: not-allowed;
            color: #3871f1;
          }

          /deep/ .ivu-select-input {
            display: inline-block;
            height: 32px;
            line-height: 32px;
            padding: 0 24px 0 8px;
            font-size: 14px;
            outline: none;
            border: none;
            box-sizing: border-box;
            color: #3871f1;
            background-color: transparent;
            position: relative;
            cursor: pointer;
          }
        }

        .SelectDesk {
          width: 91%;
          display: inline-block;
          margin-right: 10px;

          /deep/ .ivu-input[disabled] {
            background-color: #f3f3f3;
            opacity: 1;
            cursor: not-allowed;
            color: #3871f1;
          }

          /deep/ .ivu-select-input {
            display: inline-block;
            height: 32px;
            line-height: 32px;
            padding: 0 24px 0 8px;
            font-size: 14px;
            outline: none;
            border: none;
            box-sizing: border-box;
            color: #3871f1;
            background-color: transparent;
            position: relative;
            cursor: pointer;
          }
        }

        p {
          color: #00050e;
          font-size: 0.875rem;
          padding-top: 5px;
          text-align: left;
          width: 8%;
          display: inline-block;
          margin-right: 5px;
        }
      }


      .left-01 {
        display: inline-block;
        width: 90.5%;

        vertical-align: top;
        

        /deep/ .ivu-input {
          display: inline-block;
          width: 100%;
          height: calc(25%);
          line-height: 1.5;
          padding: 4px 7px;
          font-size: 14px;
          border: 1px solid #dcdee2;
          border-radius: 4px;
          color: #3871f1;
          background-color: #fff;
          background-image: none;
          position: relative;
          cursor: text;
          transition: border 0.2s ease-in-out, background 0.2s ease-in-out,
            box-shadow 0.2s ease-in-out;
        }
      }

      .left-02 {
        width: 90.7%;
        border-radius: 5px;
        background-color: #f3f3f3;
        border: 1px rgb(220, 222, 226) solid;
        height: 100px;
        color: #ee0000;
        margin-left: 8.4%;
      }
    }

    .third-line {
      margin-top: calc(20px);
      width: calc(100%);
      display: flex;
      justify-content: flex-start;
      margin-bottom: 20px;

      div {
        display: flex;
        justify-content: flex-start;
        width: 100%;

        .SelectT {
          width: 100%;
          display: inline-block;
          margin-right: 10px;

          /deep/ .ivu-input[disabled] {
            background-color: #f3f3f3;
            opacity: 1;
            cursor: not-allowed;
            color: #3871f1;
          }

          /deep/ .ivu-select-input {
            display: inline-block;
            height: 32px;
            line-height: 32px;
            padding: 0 24px 0 8px;
            font-size: 14px;
            outline: none;
            border: none;
            box-sizing: border-box;
            color: #3871f1;
            background-color: transparent;
            position: relative;
            cursor: pointer;
          }
        }

        .SelectDesk {
          width: 91%;
          display: inline-block;
          margin-right: 10px;

          /deep/ .ivu-input[disabled] {
            background-color: #f3f3f3;
            opacity: 1;
            cursor: not-allowed;
            color: #3871f1;
          }

          /deep/ .ivu-select-input {
            display: inline-block;
            height: 32px;
            line-height: 32px;
            padding: 0 24px 0 8px;
            font-size: 14px;
            outline: none;
            border: none;
            box-sizing: border-box;
            color: #3871f1;
            background-color: transparent;
            position: relative;
            cursor: pointer;
          }
        }

        p {
          color: #00050e;
          font-size: 0.875rem;
          padding-top: 5px;
          text-align: left;
          width: 11%;
          display: inline-block;
          margin-right: 5px;
        }
      }


      .left-01 {
        display: inline-block;
        width: 90.5%;

        vertical-align: top;

        /deep/ .ivu-input {
          display: inline-block;
          width: 100%;
          height: calc(25%);
          line-height: 1.5;
          padding: 4px 7px;
          font-size: 14px;
          border: 1px solid #dcdee2;
          border-radius: 4px;
          color: #3871f1;
          background-color: #fff;
          background-image: none;
          position: relative;
          cursor: text;
          transition: border 0.2s ease-in-out, background 0.2s ease-in-out,
            box-shadow 0.2s ease-in-out;
        }
      }

      .left-02 {
        width: 90.7%;
        border-radius: 5px;
        background-color: #f3f3f3;
        border: 1px rgb(220, 222, 226) solid;
        height: 100px;
        color: #ee0000;
        margin-left: 8.4%;
        overflow: scroll;
      }
    }

    .compare-line {
      margin-top: calc(10px);
      width: calc(87%);
      display: flex;
      justify-content: flex-start;
      margin-bottom: 20px;

      div {
        display: flex;
        justify-content: flex-start;
        width: 100%;

        .Select {
          width: 43%;
          display: inline-block;
          margin-right: 10px;

          /deep/ .ivu-input[disabled] {
            background-color: #f3f3f3;
            opacity: 1;
            cursor: not-allowed;
            color: #3871f1;
          }
        }

        p {
          color: #00050e;
          font-size: 0.875rem;
          padding-top: 5px;
          text-align: left;
          width: 8.5%;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }

    .service-line {
      margin-top: calc(200px);
      width: calc(87%);
      display: flex;
      justify-content: flex-start;
      margin-bottom: 20px;

      div {
        display: flex;
        justify-content: flex-start;
        width: 100%;

        .Select {
          width: 43%;
          display: inline-block;
          margin-right: 10px;

          /deep/ .ivu-input[disabled] {
            background-color: #f3f3f3;
            opacity: 1;
            cursor: not-allowed;
            color: #3871f1;
          }
        }

        p {
          color: #00050e;
          font-size: 0.875rem;
          padding-top: 5px;
          text-align: left;
          width: 8.5%;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }



    .workleft-1 {
      height: 33px;
      margin-top: 200px;
      width: 100%;

      .workleft-11 {
        font-size: 12px;
        display: flex;

        .RadioGroup {

          color: #00050e;
          margin-top: 4px;
          width: 30%;
        }

        .left-12-Select {
          width: 30%;
          display: inline-block;
        }


        p {
          color: #00050e;
          width: 8%;
          margin-right: calc(20px);
          padding-top: 5px;
          font-size: 14px;
        }
      }

    }

    .workleft-6 {
      height: 33px;
      margin-top: 445px;
      width: 100%;

      .workleft-66 {
        font-size: 12px;
        display: flex;

        .RadioGroup {

          color: #00050e;
          margin-top: 4px;
          width: 30%;
        }

        .left-66-Select {
          width: 30%;
          display: inline-block;
        }


        p {
          color: #00050e;
          width: 8%;
          margin-right: calc(20px);
          padding-top: 5px;
          font-size: 14px;
        }
      }

    }

    .workleft-2 {
      position: absolute;
      width: 73.8%;
      bottom: 15px;

      .button2 {
        width: 100%;
      }
    }

    .workleft-3 {
      position: absolute;
      width: 74%;
      bottom: 15px;

      .button2 {
        width: 100%;
      }
    }

    .workleft-4 {
      position: absolute;
      margin-left: 37.3%;
      width: 36.7%;
      bottom: 15px;

      .button2 {
        width: 100%;
      }
    }

    .workleftCompare {
      margin-top: calc(10px);

      .knowledge {
        margin: 10px 5px 5px 120px;
        width: 125px;
        height: 32px;
        background-color: #1890ff;
        color: #f6f8f7;
        border: none;
        border-radius: 5px;
      }

      .submit {
        margin: 10px 5px 5px 5px;
        width: 80px;
        height: 32px;
        background-color: #1890ff;
        color: #f6f8f7;
        border: none;
        border-radius: 5px;
      }
    }
  }

  .workcenter {
    width: 30%;
    height: 100%;

    i {
      cursor: pointer;
    }

    .center-01 {
      color: #00050e;
      width: 100%;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
    }

    .center-02 {
      height: 580px;

      .center-03 {
        height: 100%;
        overflow: auto;
        width: 300px;

        /deep/ .ivu-table {
          width: inherit;
          height: 100%;
          max-width: 100%;
          overflow: hidden;
          color: #3871f1;
          font-size: 14px;
          background-color: #fff;
          box-sizing: border-box;
        }
      }
    }
  }
}

.sum-card-box2 {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: #f9f9f9;

}
</style>
